module.exports = __webpack_public_path__ + "static/media/sound.0e8af1db.svg";